// アプリケーション全体の設定値を一元管理
import { ENVIRONMENT } from './environment';

// reCAPTCHA設定
export const RECAPTCHA_CONFIG = {
  SITE_KEY:
    process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
    '6LdC2HwrAAAAAAV2_ItzUcbfL_PwVBujr0SrphPf',
  ACTION: 'contact_form',
};

// API設定
export const API_CONFIG = {
  GAS_WEB_APP_URL:
    process.env.REACT_APP_GAS_WEB_APP_URL ||
    'https://script.google.com/macros/s/AKfycbwSRF9EmjxvxPS5fVdSnDLcyR23sCHEiZ1nLpluCDhXopaSnMQQaSlIgaeCxrdGC1wy-w/exec',
  CONTACT_ENDPOINT: '/contact',
};

export const CONTACT_FORM_CONFIG = {
  MODE: ENVIRONMENT.CONTACT_FORM_MODE,
  IS_ENABLED: ENVIRONMENT.CONTACT_FORM_MODE === 'production',
};

// ネットワーク設定
export const NETWORK_CONFIG = {
  // 低速ネットワークの判定基準（Mbps）
  SLOW_CONNECTION_THRESHOLD: 1.0,
  // 低速ネットワークの判定基準（RTT ms）
  SLOW_RTT_THRESHOLD: 150,
  // 動画を無効化するネットワークタイプ
  DISABLE_VIDEO_TYPES: ['slow-2g', '2g'],
};

// ヒーローセクション設定
export const HERO_CONFIG = {
  VIDEOS: [
    '/assets/videos/video1.WebM',
    '/assets/videos/video2.WebM',
    '/assets/videos/video3.WebM',
  ],
  // 動画の長さ（秒）- 実際の動画ファイルの長さに合わせて調整
  // 動画2が短いため、最低表示時間を調整
  VIDEO_DURATIONS: [15, 11, 19],
  // フォールバック画像（動画が読み込めない場合に使用）
  FALLBACK_IMAGES: [
    '/assets/images/hero1.jpg',
    '/assets/images/hero2.jpg',
    '/assets/images/hero3.jpg',
  ],
  // フォールバック画像の表示時間（ミリ秒）
  FALLBACK_IMAGE_DURATION: 10000,
  // クロスフェード設定
  CROSSFADE_DURATION: 2000, // 2秒（ミリ秒）
  CROSSFADE_START_BEFORE_END: 1000, // 動画終了の1秒前に開始
  TRANSITION_DURATION: 1000, // ミリ秒
  MAX_CONTENT_DURATION: 8000, // 最大表示時間（ミリ秒）
  MIN_CONTENT_DURATION: 5000, // 最小表示時間（ミリ秒）
  TYPING_SPEED: 80, // 1文字あたりのミリ秒
  TYPING_DELAY: 800, // 開始までの遅延
};

// アニメーション設定
export const ANIMATION_CONFIG = {
  FADE_IN_THRESHOLD: 0.1,
  FADE_IN_ROOT_MARGIN: '0px 0px -10% 0px',
  SCROLL_DURATION: 800,
};

// ブレークポイント
export const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1280,
  LARGE: 1536,
  XL: 1920,
};

// フォームバリデーション
export const FORM_VALIDATION = {
  MAX_NAME_LENGTH: 100,
  MAX_MESSAGE_LENGTH: 5000,
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};

// エラーメッセージ
export const ERROR_MESSAGES = {
  RECAPTCHA_FAILED: 'セキュリティ検証に失敗しました。',
  NETWORK_ERROR: 'ネットワークエラーが発生しました。',
  VALIDATION_ERROR: '入力内容を確認してください。',
  GENERIC_ERROR: 'エラーが発生しました。しばらくしてから再度お試しください。',
};
